export default __webpack_public_path__ + "static/media/reports-19.7afd5eb6.png";